import { useRef } from "react";

import * as theme from "./AIQuickPrompts.css";
import { AIQuickPromptsProps } from "./AIQuickPrompts.types";

export function AIQuickPrompts({ title, prompts }: AIQuickPromptsProps) {
    const hasFiredRef = useRef(false);

    const fireOnce = (onClick: () => void) => () => {
        if (hasFiredRef.current) {
            return;
        }
        hasFiredRef.current = true;
        onClick();
    };

    return (
        <div className={theme.root}>
            <h3 className={theme.title}>{title}</h3>
            <div className={theme.promptList}>
                {prompts.map((prompt, index) => (
                    <button
                        key={index}
                        type="button"
                        className={theme.promptButton}
                        onClick={fireOnce(prompt.onClick)}
                    >
                        <span className={theme.promptIcon}>{prompt.icon}</span>
                        {prompt.label}
                    </button>
                ))}
            </div>
        </div>
    );
}
